export default "__VITE_ASSET__D1SOAAn___"